import { atom } from 'recoil';
import { SoNetMailInfoResponse } from '@/types/api/mypage/soNetMailInfo';
import persistAtom from './recoilPersist';

/**
 * So-net メールシステム情報を保持する state。
 * 契約情報画面でメールアドレスと利用状態を表示するため、取得済み情報をセッションに保持する。
 */
const SoNetMailInfoState = atom<SoNetMailInfoResponse>({
  key: 'SoNetMailInfoState',
  default: {
    mail_addr: '',
    status: '',
  },
  effects_UNSTABLE: [persistAtom],
});

export default SoNetMailInfoState;
